import styled from 'styled-components';

const AccountDeletionPage = () => (
  <Wrap>
    <Inner>
      <Title>계정 및 데이터 삭제 요청</Title>
      <Meta>(주)이음플렛폼 · desk@ieum.in · 070-7666-9413</Meta>

      <Lead>
        이음 앱을 이용하시는 분이 계정과 관련 데이터를 삭제하고자 하실 경우,
        아래 두 가지 방법 중 편하신 방법을 선택해 주세요.
      </Lead>

      <Section>
        <H>방법 ① 앱 내 회원탈퇴 (즉시 삭제)</H>
        <Body>
          앱에 로그인한 뒤 <b>마이페이지 → 회원정보 수정 → 회원탈퇴</b> 메뉴에서 직접 탈퇴할 수 있습니다.
          탈퇴 즉시 계정은 비활성화되며, 본인 식별 정보(이름·연락처·이메일)는 보유 기간 종료 후 자동 파기됩니다.
        </Body>
      </Section>

      <Section>
        <H>방법 ② 이메일로 요청 (담당자 처리)</H>
        <Body>
          앱 접근이 어려우시거나 별도 사유가 있을 경우 아래 이메일로 요청해 주세요.
          영업일 기준 7일 이내에 처리 결과를 회신드립니다.
        </Body>
        <Mailto href="mailto:desk@ieum.in?subject=[이음] 계정 및 데이터 삭제 요청">
          desk@ieum.in
        </Mailto>
        <Body>요청 시 아래 정보를 함께 보내주세요:</Body>
        <Ul>
          <li>가입 이메일 또는 휴대전화번호 (본인확인 목적)</li>
          <li>삭제 요청 사유 (선택)</li>
        </Ul>
      </Section>

      <Section>
        <H>삭제되는 데이터</H>
        <Ul>
          <li>계정 식별 정보 — 이름, 이메일, 전화번호, 비밀번호</li>
          <li>프로필 정보 — 사업자등록증, 사업자번호, 대표자명, 주소</li>
          <li>이용 기록 — 추천 고객 리스트, 정산 기록, 알림 설정, 디바이스 토큰</li>
        </Ul>
      </Section>

      <Section>
        <H>법령에 따라 일정 기간 보관되는 데이터</H>
        <Body>
          관련 법령에 따라 회원 탈퇴 후에도 일정 기간 의무적으로 보관되는 데이터가 있습니다.
        </Body>
        <Table>
          <thead><tr><th>항목</th><th>보유 기간</th><th>근거 법령</th></tr></thead>
          <tbody>
            <tr><td>계약/청약철회 기록</td><td>5년</td><td>전자상거래법</td></tr>
            <tr><td>대금결제 및 재화 공급 기록</td><td>5년</td><td>전자상거래법</td></tr>
            <tr><td>소비자 불만/분쟁처리 기록</td><td>3년</td><td>전자상거래법</td></tr>
            <tr><td>로그인 기록</td><td>3개월</td><td>통신비밀보호법</td></tr>
          </tbody>
        </Table>
        <Body>
          상기 보유 기간 경과 후에는 별도 요청 없이도 자동 파기되며, 어떠한 목적으로도 다시 이용되지 않습니다.
        </Body>
      </Section>

      <Section>
        <H>문의처</H>
        <Table>
          <tbody>
            <tr><th>운영 주체</th><td>(주)이음플렛폼</td></tr>
            <tr><th>대표자</th><td>이은송</td></tr>
            <tr><th>이메일</th><td>desk@ieum.in</td></tr>
            <tr><th>전화</th><td>070-7666-9413</td></tr>
            <tr><th>주소</th><td>경기도 시흥시 서울대학로278번길 19-14, 배곧프라자 706호</td></tr>
          </tbody>
        </Table>
      </Section>

      <Footer>
        최종 수정일 2026-04-26 · 본 안내는 「개인정보 보호법」 및 「위치정보의 보호 및 이용 등에 관한 법률」을 따릅니다.
      </Footer>
    </Inner>
  </Wrap>
);

const Wrap = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 32px 16px 80px;
`;
const Inner = styled.div`
  max-width: 760px;
  margin: 0 auto;
  font-family: 'Apple SD Gothic Neo', 'Pretendard', sans-serif;
  color: #1F2937;
  line-height: 1.7;
  font-size: 14px;
`;
const Title = styled.h1`
  font-size: 26px;
  font-weight: 700;
  border-bottom: 3px solid #4A6CF7;
  padding-bottom: 12px;
  margin: 0 0 8px;
`;
const Meta = styled.div`
  color: #6B7280;
  font-size: 12px;
  margin-bottom: 32px;
`;
const Lead = styled.p`
  background: #F9FAFB;
  padding: 14px 16px;
  border-radius: 6px;
  margin: 0 0 28px;
`;
const Section = styled.section`margin-bottom: 32px;`;
const H = styled.h2`
  font-size: 16px;
  color: #4A6CF7;
  border-left: 3px solid #4A6CF7;
  padding-left: 10px;
  margin: 0 0 10px;
`;
const Body = styled.p`margin: 8px 0;`;
const Ul = styled.ul`padding-left: 20px; margin: 8px 0;`;
const Mailto = styled.a`
  display: inline-block;
  background: #4A6CF7;
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  margin: 8px 0;
  &:hover { background: #3B5BDB; }
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 13px;
  th, td { border: 1px solid #E5E7EB; padding: 8px 12px; text-align: left; vertical-align: top; }
  th { background: #F3F4F6; font-weight: 600; width: 30%; }
`;
const Footer = styled.div`
  margin-top: 40px;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 6px;
  font-size: 12px;
  color: #6B7280;
`;

export default AccountDeletionPage;
